import { render, staticRenderFns } from "./alt-copy.vue?vue&type=template&id=74b5d697&scoped=true&"
import script from "./alt-copy.vue?vue&type=script&lang=js&"
export * from "./alt-copy.vue?vue&type=script&lang=js&"
import style0 from "./alt-copy.vue?vue&type=style&index=0&id=74b5d697&lang=scss&scoped=true&"
import style1 from "./alt-copy.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b5d697",
  null
  
)

export default component.exports